import React, { useState, useEffect } from "react";
import { mdiCog } from "@mdi/js";
import { getUrl } from "utils/utils";
import "react-dropdown/style.css";
import { Breadcrumb } from "common/Breadcrumb";
import { TitlePage } from "common/TitlePage";
import { getUserLogin } from "utils/utils";
import { GetRoleParentCap1ByLink } from "utils/utils";
import { pushNotification } from "utils/notifications";
import iconCustomer from "Resources/ImagesNew/Group2196.png";
import DanhSachNguoiDungApi from "../../../service/HeThong/DanhSachNguoiDungApi";
export const DoiMatKhau = () => {
  document.title = "Đổi mật khẩu người dùng";

  const [getLink, setGetLink] = useState();

  useEffect(() => {}, []);
  const init = {
    userName: getUserLogin().UserName,
    hoten: "",
    sodienthoai: "",
    email: "",
    matkhaucu: "",
    matkhaumoi: "",
    nhaplaimatkhaumoi: "",
  };
  const [dataUser, setDataUser] = useState(init);

  useEffect(() => {
    //GetFullUser();
  }, []);

  // const GetFullUser = () => {
  //     DanhSachNguoiDungApi.chitietnguoidungdaily(dataUser.userName).then((response) => {
  //         if (response.status === 200) {
  //             if (response.data) {
  //                 setDataUser({
  //                     ...dataUser,
  //                     hoten: response.data.FullName,
  //                     sodienthoai: response.data.Email,
  //                     email: response.data.Phone,
  //                 })
  //             }
  //         }
  //     });
  // }
  const onChangeText = (field, e) => updateStateThongTin(field, e.target.value);
  const updateStateThongTin = (field, value) => {
    const thongtin = { ...dataUser };
    thongtin[field] = value;
    setDataUser(thongtin);
  };
  const onSave = () => {
    if (dataUser.matkhaucu == "") {
      pushNotification("Nhập mật khẩu cũ", "error", "TOP_RIGHT", 2000);
      return;
    }
    if (dataUser.matkhaumoi == "") {
      pushNotification("Nhập mật khẩu mới", "error", "TOP_RIGHT", 2000);
      return;
    }

    if (dataUser.matkhaumoi.length < 6) {
      pushNotification(
        "Mật khẩu mới phải có ít nhất 6 ký tự",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).+$/;
    if (!passwordRegex.test(dataUser.matkhaumoi)) {
      pushNotification(
        "Mật khẩu mới phải chứa ít nhất 1 chữ cái và 1 chữ số",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }
    if (dataUser.nhaplaimatkhaumoi == "") {
      pushNotification("Nhập lại mật khẩu mới", "error", "TOP_RIGHT", 2000);
      return;
    }
    if (dataUser.matkhaumoi != dataUser.nhaplaimatkhaumoi) {
      pushNotification(
        "Hai ô nhập mật khẩu mới phải giống nhau",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    DanhSachNguoiDungApi.capnhatmatkhaudaily(
      dataUser.userName,
      dataUser.matkhaucu,
      dataUser.matkhaumoi,
      dataUser.nhaplaimatkhaumoi,
    ).then((response) => {
      if (response.status === 200) {
        if (response.data.Error == 200) {
          pushNotification(response.data.Message, "success", "TOP_RIGHT", 2000);
          setDataUser({
            ...dataUser,
            matkhaucu: "",
            matkhaumoi: "",
            nhaplaimatkhaumoi: "",
          });
        } else {
          pushNotification(response.data.Message, "error", "TOP_RIGHT", 2000);
        }
      }
    });
  };

  return (
    <div className="dealer-page">
      <div className="dealer-container">
        <div className="change-pass-card">
          <div className="change-pass-header">
            <div className="change-pass-title">
              <div className="change-pass-icon">
                <img src={iconCustomer} alt="" />
              </div>

              <span>Đổi mật khẩu</span>
            </div>

            <button
              type="button"
              className="change-pass-back-btn"
              onClick={() => {
                window.location.href = "/DatHangDaiLy";
              }}
            >
              Quay lại
            </button>
          </div>

          <div className="change-pass-section">
            <div className="change-pass-section-title">
              <i className="mdi mdi-format-list-bulleted"></i>
              <span>Thông tin tài khoản</span>
            </div>

            <div className="change-pass-grid one-column">
              <div className="change-pass-row">
                <label>Tên đăng nhập</label>

                <input type="text" value={dataUser.userName} disabled={true} />
              </div>
            </div>
          </div>

          <div className="change-pass-section">
            <div className="change-pass-section-title">
              <i className="mdi mdi-format-list-bulleted"></i>
              <span>Đổi mật khẩu</span>
            </div>

            <div className="change-pass-grid">
              <div className="change-pass-row">
                <label>Mật khẩu cũ</label>

                <input
                  type="password"
                  value={dataUser.matkhaucu}
                  onChange={(e) => onChangeText("matkhaucu", e)}
                />
              </div>

              <div className="change-pass-row">
                <label>Mật khẩu mới</label>

                <input
                  type="password"
                  value={dataUser.matkhaumoi}
                  onChange={(e) => onChangeText("matkhaumoi", e)}
                />
              </div>

              <div className="change-pass-row">
                <label>Nhập lại mật khẩu</label>

                <input
                  type="password"
                  value={dataUser.nhaplaimatkhaumoi}
                  onChange={(e) => onChangeText("nhaplaimatkhaumoi", e)}
                />
              </div>
            </div>
          </div>

          <div className="change-pass-footer">
            <button
              type="button"
              className="change-pass-back-btn"
              onClick={() => {
                window.location.href = "/DatHangDaiLy";
              }}
            >
              Quay lại
            </button>

            <button type="button" onClick={() => onSave()}>
              Lưu thông tin
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
